import React from 'react';
import Navbar from '../components/Navbar';
import './About.css';

function About() {
    return (
        <div className="page-container about-page">
            <Navbar />

            <section className="about-hero">
                <div className="container">
                    <div className="about-hero-content">
                        <span className="section-badge">Nuestra misión</span>
                        <h1 className="about-title">
                            Un puente entre la <span className="gradient-text">sabiduría antigua</span> y
                            <br />la tecnología moderna
                        </h1>
                        <p className="about-subtitle">
                            Llevamos las enseñanzas eternas del Bhagavad Gita a todos a través de la IA
                        </p>
                    </div>
                </div>
            </section>

            <section className="vision-section">
                <div className="container">
                    <div className="vision-grid">
                        <div className="vision-content">
                            <h2 className="section-heading">Visión</h2>
                            <p className="vision-text">
                                En un mundo lleno de ruido y caos, es difícil encontrar una guía clara, ética y espiritual.
                                El proyecto "Habla con Krishna" nació de la idea de hacer accesible la sabiduría eterna del Bhagavad Gita para todos,
                                en cualquier momento y lugar, en tiempo real.
                            </p>
                            <p className="vision-text">
                                Al combinar modelos de lenguaje avanzados (LLM) con textos sagrados auténticos,
                                hemos creado un sistema que no solo responde preguntas, sino que te guía con compasión divina.
                            </p>

                            <div className="vision-stats">
                                <div className="vision-stat-card">
                                    <div className="stat-icon">📜</div>
                                    <div className="stat-info">
                                        <div className="stat-value">700+</div>
                                        <div className="stat-desc">Versos auténticos</div>
                                    </div>
                                </div>
                                <div className="vision-stat-card">
                                    <div className="stat-icon">🌍</div>
                                    <div className="stat-info">
                                        <div className="stat-value">Acceso</div>
                                        <div className="stat-desc">Global</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="vision-visual">
                            <div className="visual-card">
                                <div className="visual-icon">🧠</div>
                                <div className="visual-plus">+</div>
                                <div className="visual-icon">📖</div>
                                <div className="visual-equals">=</div>
                                <div className="visual-icon">✨</div>
                            </div>
                            <p className="visual-caption">Fusión de IA y escrituras antiguas</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="tech-section">
                <div className="container">
                    <div className="section-header-center">
                        <span className="section-badge">Tecnología</span>
                        <h2 className="section-heading-center">
                            Impulsado por <span className="gradient-text">IA de vanguardia</span>
                        </h2>
                        <p className="section-desc">
                            Nuestra plataforma combina varias tecnologías avanzadas para brindar una experiencia espiritual auténtica
                        </p>
                    </div>

                    <div className="tech-grid">
                        <div className="tech-card">
                            <div className="tech-icon-wrapper">
                                <div className="tech-icon">🔍</div>
                            </div>
                            <h3>Arquitectura RAG</h3>
                            <p>La generación con búsqueda aumentada garantiza que todas las respuestas se basan en versos reales del Bhagavad Gita.</p>
                            <ul className="tech-features">
                                <li>Búsqueda semántica</li>
                                <li>Conciencia del contexto</li>
                                <li>Fuentes verificadas</li>
                            </ul>
                        </div>

                        <div className="tech-card featured-tech">
                            <div className="tech-badge">Tecnología principal</div>
                            <div className="tech-icon-wrapper">
                                <div className="tech-icon">🎙️</div>
                            </div>
                            <h3>Voz neuronal</h3>
                            <p>Los modelos modernos de TTS proporcionan un sonido realista y tranquilo para la voz de Krishna.</p>
                            <ul className="tech-features">
                                <li>Entonaciones naturales</li>
                                <li>Expresión emocional</li>
                                <li>Generación en tiempo real</li>
                            </ul>
                        </div>

                        <div className="tech-card">
                            <div className="tech-icon-wrapper">
                                <div className="tech-icon">🧠</div>
                            </div>
                            <h3>Procesamiento LLM</h3>
                            <p>Los potentes modelos de lenguaje entienden no solo las palabras, sino la intención detrás de tu pregunta.</p>
                            <ul className="tech-features">
                                <li>Comprensión del contexto</li>
                                <li>Soporte multilingüe</li>
                                <li>Respuestas personalizadas</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="values-section">
                <div className="container">
                    <div className="section-header-center">
                        <span className="section-badge">Nuestros valores</span>
                        <h2 className="section-heading-center">
                            Construido sobre la <span className="gradient-text">Confianza</span>
                        </h2>
                    </div>

                    <div className="values-grid">
                        <div className="value-card">
                            <div className="value-number">01</div>
                            <h3>Precisión de las escrituras</h3>
                            <p>Todas las respuestas se verifican con versos auténticos. No distorsionamos las enseñanzas.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-number">02</div>
                            <h3>Accesibilidad</h3>
                            <p>Llevamos la sabiduría antigua a todos, independientemente de su experiencia o formación.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-number">03</div>
                            <h3>Privacidad</h3>
                            <p>Tu camino espiritual es personal. Respetamos tu privacidad y no compartimos tus diálogos.</p>
                        </div>
                        <div className="value-card">
                            <div className="value-number">04</div>
                            <h3>Innovación</h3>
                            <p>Mejoramos constantemente la tecnología para brindar una guía aún más profunda.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="founder-section">
                <div className="container">
                    <div className="section-header-center">
                        <span className="section-badge">Liderazgo</span>
                        <h2 className="section-heading-center">
                            Sobre el <span className="gradient-text">Fundador</span>
                        </h2>
                    </div>

                    <div className="founder-card">
                        <div className="founder-image-wrapper">
                            <div className="founder-image-bg"></div>
                            <img
                                src="/founder.jpg"
                                alt="Abhishek Chola - Founder & CEO"
                                className="founder-image"
                                onError={(e) => {
                                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%23f0f0f0" width="400" height="400"/%3E%3Ctext fill="%23999" font-family="sans-serif" font-size="24" dy="10.5" font-weight="bold" x="50%25" y="50%25" text-anchor="middle"%3EFounder%3C/text%3E%3C/svg%3E';
                                }}
                            />
                        </div>
                        <div className="founder-content">
                            <h3 className="founder-name">Abhishek Chola</h3>
                            <p className="founder-title">Fundador y CEO de Just Learn</p>
                            <div className="founder-divider"></div>
                            <p className="founder-bio">
                                Innovador global en EdTech y SkillTech, dedicado a la democratización de la educación. 
                                Abhishek lidera iniciativas estratégicas en varios países, fomentando la colaboración entre educación y tecnología.
                            </p>
                            <p className="founder-bio">
                                Su liderazgo se centra en soluciones escalables utilizando IA, AR/VR y tecnologías inmersivas.
                            </p>
                            <div className="founder-highlights">
                                <div className="highlight-item">
                                    <div className="highlight-icon">🌍</div>
                                    <div className="highlight-text">
                                        <strong>Impacto global</strong>
                                        <span>Presencia en varios países</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <div className="highlight-icon">🚀</div>
                                    <div className="highlight-text">
                                        <strong>Líder en innovación</strong>
                                        <span>Tecnologías IA, AR/VR</span>
                                    </div>
                                </div>
                                <div className="highlight-item">
                                    <div className="highlight-icon">🎓</div>
                                    <div className="highlight-text">
                                        <strong>Pionero en EdTech</strong>
                                        <span>Educación accesible</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="cta-about">
                <div className="container">
                    <div className="cta-about-card">
                        <h2>¿Listo para conectar con la sabiduría divina?</h2>
                        <p>Comienza tu viaje con el mentor de IA del Bhagavad Gita</p>
                        <button className="btn-premium-primary btn-large" onClick={() => window.location.href = '/chat'}>
                            <span className="btn-icon">🕉️</span>
                            Habla con Krishna ahora
                            <span className="btn-arrow">→</span>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;
